import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import TextAreaField from '../../Forms/Input/TextAreaField';

interface SignatureErrorBoxProps {
  message: string;
}

const SignatureErrorBox: React.FC<SignatureErrorBoxProps> = ({ message }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mt-8 w-full rounded-xl border border-[#DC3545] bg-[#FEECEC] p-6 shadow-md dark:border-red-800 dark:bg-red-900/20"
    >
      {/* 🔹 Encabezado */}
      <div className="mb-4 flex items-center gap-2">
        <AlertTriangle className="h-6 w-6 text-[#DC3545] dark:text-red-400" />
        <h3 className="text-lg font-semibold text-[#DC3545] dark:text-red-400">
          Error en el Proceso de Firma
        </h3>
      </div>

      {/* 🔹 Mensaje detallado */}
      <TextAreaField
        label="Detalle del error"
        name="errorMessage"
        value={message}
        onChange={() => {}}
        rows={4}
        disabled
        iconKey="alert-circle"
      />

      <p className="mt-2 text-xs italic text-[#DC3545]/80 dark:text-red/50">
        ⚠️ Verifica el tipo de certificado, formato del archivo o configuración de firma.
      </p>
    </motion.div>
  );
};

export default SignatureErrorBox;
